<template>
	<div class="containerMain">
		<title-bar :topTitle="true" :topTitleText="`Reporte de ${this.reportName}`"/>
		<div class="row between d-flex justify-content-end mr-2 mt-4 mb-0 d-flex justify-content-end">
			<b-form-group label-size="1" label="Fecha Inicio" label-for="startDate" class="mr-2">
				<datepicker calendar-class="calendar" input-class="form-control cursor-pointer" v-model="startDate" name="startDate" format="dd/MM/yyyy" placeholder="Tocar para seleccionar fecha"></datepicker><br>
			</b-form-group>
			<b-form-group label-size="1" label="Fecha Fin" label-for="endDate" class="mr-2">
				<datepicker calendar-class="calendar" input-class="form-control cursor-pointer" v-model="endDate" name="endDate" format="dd/MM/yyyy" placeholder="Tocar para seleccionar fecha"></datepicker><br>
			</b-form-group>
			<b-button class="mr-2" style="height: 4rem;font-size: 1.6rem;" :disabled="!endDate || !startDate" variant="primary" @click="loadData()">Consultar</b-button>
			<b-button class="mr-2" style="height: 4rem;font-size: 1.6rem;" variant="secondary" @click="exportData()">Exportar</b-button>
			<div>
				<b-form-select style="height: 4rem;font-size: 1.6rem;" v-model="exportOption" :options="[{text: 'txt', value: 'txt'},{text: 'xls', value: 'xls'}]"></b-form-select>
			</div>
		</div>
		<div class="col inner" v-if="history && history.length > 0">
			<b-form-input
	      v-model="textFilter"
	      type="search"
	      id="filterInput"
	      placeholder="Escribe para filtrar"
	    >
	    </b-form-input>
			<div class="col between innerRubric sd">
				<b-table td-class="text-justify" :filter="textFilter" responsive style="cursor: pointer;" class="category all" striped hover :items="history" :fields="tableFields" @row-clicked="onRowClick">
					<template slot="date" slot-scope="item">
						{{item.value ? getHumanDateAndTime(item.value) : 'Sin fecha'}}
					</template>
					<template slot="title" slot-scope="item">
						{{item.value || 'Sin título'}}
					</template>
				</b-table>
			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import helpers from '@/helpers';
import mediator from '@/mediator';
import Datepicker from 'vuejs-datepicker';
import FileSaver from 'file-saver';

export default {
	components: {
		Datepicker
	},
	props: ['synthesisTypeId'],
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	created () {
		this.startDate = this.$store.state.persistent.academicYear.startDate;
		this.endDate = this.$store.state.persistent.academicYear.endDate;
	},
	data () {
		return {
			startDate: null,
			endDate: null,
			textFilter: '',
			exportOption: 'xls',
			tableFieldsBase: null
		};
	},
	watch: {
		async synthesisTypeId () {
			this.loadData();
		}
	},
	computed: {
		history () {
			if (!this.$store.state.admin.schoolHistory) return null;
			return this.$store.state.admin.schoolHistory.map((history) => {
				if (history.data) {
					let type = typeof history.data;
					if (type !== 'object') history.data = JSON.parse(history.data);
				} else return history;
				if (this.synthesisTypeId == 1) history = this.getVisitClosuresRow(history);
				else if (this.synthesisTypeId == 2) history = this.getTrainingRow(history);
				else if (this.synthesisTypeId == 3) history = this.getDiagnosticRow(history);
				else if (this.synthesisTypeId == 5) history = this.getIndicatorsRow(history);
				return history;
			});
		},
		tableFields () {
			if (this.synthesisTypeId == 1) return this.getVisitCloseHeaders();
			if (this.synthesisTypeId == 2) return this.getTrainingHeaders();
			if (this.synthesisTypeId == 3) return this.getDiagnosticHeaders();
			if (this.synthesisTypeId == 5) return this.getIndicatorsHeaders();
		},
		reportName (item) {
			if (this.synthesisTypeId == 1) return 'Cierres de visita';
			if (this.synthesisTypeId == 2) return 'Formaciones';
			if (this.synthesisTypeId == 3) return 'Diagnóstico actual';
			if (this.synthesisTypeId == 5) return 'Indicadores';
		},
		implemetationLevelsDropdown () {
			return this.$store.getters.implemetationLevelsDropdown;
		},
		riskFactorDropdown () {
			return this.$store.getters.riskFactorDropdown;
		},
		strategyFactorDropdown () {
			return this.$store.getters.strategyFactorDropdown;
		}
	},
	methods: {
		async loadData () {
			this.$store.dispatch('hideContent');
			await mediator.coaching.getAdminSchools();
			await mediator.coaching.getSynthesesReportByTypeId(this.synthesisTypeId, this.startDate, this.endDate);
			await this.$store.dispatch('activeMenu', this.$router.currentRoute.path);
			this.$store.dispatch('showContent');
		},
		getHumanDate (date) {
			return helpers.dateTime.getHumanDate(date);
		},
		getHumanDateAndTime (date) {
			return helpers.dateTime.getHumanDateAndTime(date);
		},
		getPersonFullName (person) {
			return helpers.persons.getPersonFullName(person);
		},
		onRowClick (item) {
			// if (this.synthesisTypeId == 1) this.$router.push(`/coaching/admin/visit-closure/${item.id}`);
			// if (this.synthesisTypeId == 2) this.$router.push(`/coaching/admin/training/${item.id}`);
			// if (this.synthesisTypeId == 3) this.$router.push(`/coaching/admin/diagnostic/${item.id}`);
			// if (this.synthesisTypeId == 5) this.$router.push(`/coaching/admin/indicator/${item.id}`);
		},
		getISODate (date) {
			return helpers.dateTime.getISODate(date);
		},
		getTrainingTalk (synthesis) {
			if (!synthesis.data.coachingTalkTypeId) return null;
			if (!this.$store.state.admin.trainingTalks) return null;
			return this.$store.state.admin.trainingTalks.find((talk) => (talk.id == synthesis.data.coachingTalkTypeId));
		},
		getImplementationLevel (synthesis) {
			if (!synthesis.data.implementationLevel) return null;
			if (!this.implemetationLevelsDropdown) return null;
			return this.implemetationLevelsDropdown.find((level) => (level.value == synthesis.data.implementationLevel));
		},
		getRiskFactor (synthesis) {
			if (!synthesis.data.riskFactor) return null;
			if (!this.riskFactorDropdown) return null;
			return this.riskFactorDropdown.find((factor) => (factor.value == synthesis.data.riskFactor));
		},
		getStrategyFactor (synthesis) {
			if (!synthesis.data.strategyFactor) return null;
			if (!this.strategyFactorDropdown) return null;
			return this.strategyFactorDropdown.find((factor) => (factor.value == synthesis.data.strategyFactor));
		},
		getAllDataString () {
			let headers = this.tableFields;
			let headerKeys = Object.keys(headers);
			let rows = this.history;
			let rowsKeys = Object.keys(rows[0]);
			let string = '';
			// Headers
			headerKeys.forEach((header) => (string += helpers.textFilter.removeAccentsFromString(headers[header].label) + '\t'));

			string += '\n';
			// Rows
			rows.forEach((row) => {
				headerKeys.forEach((key) => (string += helpers.textFilter.removeAccentsFromString((row[key] || '')) + '\t'));
				string += '\n';
			});

			return string;
		},
		exportData () {
			let title = `Reporte de ${this.reportName}`;
			let reportDate = this.getHumanDateAndTime(new Date());
			let reportName = `${title}${reportDate}.${this.exportOption}`;
			let dataString = this.getAllDataString();
			let type;
			if (this.exportOption == 'txt') type = 'text/plain;charset=utf-8';
			else if (this.exportOption == 'csv') type = 'text/csv;charset=utf-8';
			else type = 'application/vnd.ms-excel;charset=utf-8';
			let blob = new Blob([dataString], {type});
			FileSaver.saveAs(blob, reportName);
		},
		getAcademicLevelsString (academicLevels) {
			if (!academicLevels || academicLevels.length == 0) return '';
			return academicLevels.map((level) => (level.name)).toString();
		},
		getLanguagesString (languages) {
			if (!languages || languages.length == 0) return '';
			return languages.map((language) => (language.name)).toString();
		},
		getHeaderObject (label, tdClass = null, sortable = true) {
			return {
				label,
				sortable,
				tdClass
			};
		},
		getEffectiveLeadership (synthesis) {
			if (!synthesis.data.effectiveLeadership) return null;
			return `${synthesis.data.effectiveLeadership.value}: ${synthesis.data.effectiveLeadership.description || 'Sin descripción'}`;
		},
		getDirectorRotation (synthesis) {
			if (!synthesis.data.directorRotation) return null;
			if (synthesis.data.directorRotation.rotation) return `Si: ${synthesis.data.directorRotation.description || 'Sin descripción'}`;
			else return `No: ${synthesis.data.directorRotation.description || 'Sin descripción'}`;
		},
		getInstitutionalDiscipline (synthesis) {
			if (!synthesis.data.institutionalDiscipline) return null;
			return `${synthesis.data.institutionalDiscipline.value}: ${synthesis.data.institutionalDiscipline.description || 'Sin descripción'}`;
		},
		getVisitClosuresRow (visitClose) {
			visitClose.title = visitClose.data.name || '';
			visitClose.type = visitClose.synthesisType ? visitClose.synthesisType.name : '';
			visitClose.personName = visitClose.coach ? this.getPersonFullName(visitClose.coach) : '';
			visitClose.schoolName = visitClose.school ? visitClose.school.name : '';
			visitClose.visit = visitClose.data.visit || '';
			visitClose.description = visitClose.data.description || '';
			visitClose.observations = visitClose.data.observations || '';
			visitClose.feedback = visitClose.data.feedback || '';
			visitClose.strengths = visitClose.data.strengths || '';
			visitClose.specifications = visitClose.data.specifications || '';
			let implementationLevel = this.getImplementationLevel(visitClose);
			visitClose.implementationLevel = implementationLevel ? implementationLevel.text : '';
			visitClose.academicLevels = this.getAcademicLevelsString(visitClose.data.academicLevels);
			visitClose.languages = this.getLanguagesString(visitClose.data.languages);
			return visitClose;
		},
		getVisitCloseHeaders () {
			let headers = {};
			headers.date = this.getHeaderObject('Fecha');
			headers.schoolName = this.getHeaderObject('Colegio');
			headers.type = this.getHeaderObject('Tipo');
			headers.title = this.getHeaderObject('Título/Nombre');
			headers.personName = this.getHeaderObject('Coach');
			headers.visit = this.getHeaderObject('Visita');
			headers.description = this.getHeaderObject('Comentario general');
			headers.observations = this.getHeaderObject('Puntos importantes');
			headers.specifications = this.getHeaderObject('Especificaciones');
			headers.feedback = this.getHeaderObject('Áreas de mejora');
			headers.strengths = this.getHeaderObject('Fortalezas');
			headers.implementationLevel = this.getHeaderObject('Nivel de implementación');
			headers.academicLevels = this.getHeaderObject('Niveles');
			headers.languages = this.getHeaderObject('Idiomas');
			return headers;
		},
		getTrainingRow (training) {
			training.title = training.data.name;
			let trainingTalk = this.getTrainingTalk(training);
			training.formation = trainingTalk ? trainingTalk.title : '';
			if (training.data.formationType)	{
				training.type = training.data.formationType == 'forParents'
				|| training.data.formationType == 1 ? 'Plática para padres' : 'Capacitación';
			}
			else training.type = 'Formación';
			training.personName = training.coach ? this.getPersonFullName(training.coach) : '';
			training.schoolName = training.school ? training.school.name : '';
			training.formationSpeaker = training.data.formationSpeaker || '';
			training.specifications = training.data.specifications || '';
			training.academicLevels = this.getAcademicLevelsString(training.data.academicLevels);
			training.languages = this.getLanguagesString(training.data.languages);
			return training;
		},
		getTrainingHeaders () {
			let headers = {};
			headers.date = this.getHeaderObject('Fecha');
			headers.schoolName = this.getHeaderObject('Colegio');
			headers.type = this.getHeaderObject('Tipo');
			headers.title = this.getHeaderObject('Título/Nombre');
			headers.personName = this.getHeaderObject('Coach');
			headers.formation = this.getHeaderObject('Formación');
			headers.formationSpeaker = this.getHeaderObject('Ponente');
			headers.specifications = this.getHeaderObject('Especificaciones');
			headers.academicLevels = this.getHeaderObject('Niveles');
			headers.languages = this.getHeaderObject('Idiomas');
			return headers;
		},
		getDiagnosticRow (diagnostic) {
			diagnostic.title = diagnostic.data.name || '';
			diagnostic.type = diagnostic.synthesisType ? diagnostic.synthesisType.name : '';
			diagnostic.personName = diagnostic.coach ? this.getPersonFullName(diagnostic.coach) : '';
			diagnostic.schoolName = diagnostic.school ? diagnostic.school.name : '';
			diagnostic.currentRiskFactor = diagnostic.data.currentRiskFactor || '';
			let riskFactor = this.getRiskFactor(diagnostic);
			diagnostic.riskFactor = riskFactor ? riskFactor.text : '';
			let directorRotation = this.getDirectorRotation(diagnostic);
			diagnostic.directorRotation = directorRotation || '';
			let effectiveLeadership = this.getEffectiveLeadership(diagnostic);
			diagnostic.effectiveLeadership = effectiveLeadership || '';
			let institutionalDiscipline = this.getInstitutionalDiscipline(diagnostic);
			diagnostic.institutionalDiscipline = institutionalDiscipline || '';
			diagnostic.internalAllies = diagnostic.data.internalAllies || '';
			diagnostic.interventionStrategy = diagnostic.data.interventionStrategy || '';
			let strategyFactor = this.getStrategyFactor(diagnostic);
			diagnostic.strategyFactor = strategyFactor ? strategyFactor.text : '';
			diagnostic.possibleGrowth = diagnostic.data.possibleGrowth || '';
			diagnostic.yearExpectations = diagnostic.data.yearExpectations || '';
			return diagnostic;
		},
		getDiagnosticHeaders () {
			let headers = {};
			headers.date = this.getHeaderObject('Fecha');
			headers.schoolName = this.getHeaderObject('Colegio');
			headers.type = this.getHeaderObject('Tipo');
			headers.title = this.getHeaderObject('Título/Nombre');
			headers.personName = this.getHeaderObject('Coach');
			headers.institutionalDiscipline = this.getHeaderObject('Disciplina institucional');
			headers.effectiveLeadership = this.getHeaderObject('Liderazgo efectivo');
			headers.directorRotation = this.getHeaderObject('Rotación directiva');
			headers.yearExpectations = this.getHeaderObject('Expectativas del colegio');
			headers.internalAllies = this.getHeaderObject('Aliado(s) interno(s)');
			headers.currentRiskFactor = this.getHeaderObject('Factor de riesgo');
			headers.riskFactor = this.getHeaderObject('Factor de riesgo');
			headers.interventionStrategy = this.getHeaderObject('Estrategias');
			headers.strategyFactor = this.getHeaderObject('Estrategias');
			headers.possibleGrowth = this.getHeaderObject('Posible crecimiento');
			return headers;
		},
		getIndicatorsRow (indicators) {
			indicators.title = indicators.data.name || '';
			indicators.type = indicators.synthesisType ? indicators.synthesisType.name : '';
			indicators.personName = indicators.coach ? this.getPersonFullName(indicators.coach) : '';
			indicators.schoolName = indicators.school ? indicators.school.name : '';
			indicators.visit = indicators.data.visit || '';
			indicators.coachingTeam = indicators.data.coachingTeam || '';
			indicators.headCoach = indicators.data.headCoach || '';
			indicators.observations = indicators.data.observations || '';
			indicators.evaluations = JSON.stringify(indicators.data.evaluations);
			indicators.keyPositions = JSON.stringify(indicators.data.keyPositions);
			indicators.talForParents = indicators.data.formations ? JSON.stringify(indicators.data.formations.find((formation) => (formation.type == 'workshop'))) : '';
			indicators.talkForTeachers = indicators.data.formations ? JSON.stringify(indicators.data.formations.find((formation) => (formation.type == 'training'))) : '';
			return indicators;
		},
		getIndicatorsHeaders () {
			let headers = {};
			headers.date = this.getHeaderObject('Fecha');
			headers.schoolName = this.getHeaderObject('Colegio');
			headers.type = this.getHeaderObject('Tipo');
			headers.title = this.getHeaderObject('Título/Nombre');
			headers.visit = this.getHeaderObject('Visita');
			headers.coachingTeam = this.getHeaderObject('Equipo Coaching');
			headers.headCoach = this.getHeaderObject('Head Coach');
			headers.observations = this.getHeaderObject('Observaciones');
			headers.evaluations = this.getHeaderObject('Evaluación');
			headers.keyPositions = this.getHeaderObject('Rotación puestos clave');
			headers.talForParents = this.getHeaderObject('Plática para padres');
			headers.talkForTeachers = this.getHeaderObject('Curso Vespertino');
			return headers;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/routes/admin/SynthesesReport.vue